module.exports = __webpack_public_path__ + "f4722dd3ce02e26c22ba3266c9b7da5b.svg";